<p class="laft-form--title">Completa los datos de la empresa</p>

<form class="laft-form" [formGroup]="companyDataForm">
  <section class="laft-form--group">
    <p class="laft-form--group-title">Datos de la cuenta</p>
    <div class="form-group-2">
      <app-input formControlName="names" label="Nombres" maxlength="50"></app-input>
      <app-input formControlName="familyNames" label="Apellidos" maxlength="50"></app-input>
    </div>
    <div class="form-group">
      <app-input isDisabled="true" formControlName="companyName" label="Razón social"></app-input>
    </div>
    <div class="form-group-2">
      <app-input isDisabled="true" formControlName="idNumber" [label]="role === Roles.CLIENT ? 'RUC' : 'Número de documento'"></app-input>
      <div class="laft-form--input-phone">
        <span class="laft-form--input-phone-label" [ngClass]="phoneError ? 'laft-form--input-phone-label-error' : ''">
          Teléfono celular <span *ngIf="phoneError"> ({{ phoneError }})</span>
        </span>
        <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true" customPlaceholder="Ingresa tu número" [searchCountryFlag]="true"
          [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
          [selectedCountryISO]="countryISO.Peru" [maxLength]="phoneNumberMaxDigit" [phoneValidation]="true"
          [separateDialCode]="true" [numberFormat]="phoneNumberFormat.International"
          searchCountryPlaceholder="Elegir país" formControlName="cellphone" (focusout)="focusOutPhone()"
          (countryChange)="countryChange($event)">
        </ngx-intl-tel-input>
      </div>
    </div>
    <app-input class="signup-email-input" formControlName="email" label="Correo electrónico" isDisabled="true">
    </app-input>
  </section>
  <section class="laft-form--group">
    <p class="laft-form--group-title">Información adicional de la empresa</p>
    <div class="form-group-2">
      <app-input formControlName="sector" label="Sector"></app-input>
      <app-input formControlName="economicalActivity" label="Actividad económica"></app-input>
    </div>
    <div *ngIf="role === Roles.CLIENT">
      <div class="form-group-2">
        <app-select formControlName="annualIncomeAmount" [options]="annualIncomeOptions" valueField="value" textField="text"
          label="Monto de ingresos anuales"></app-select>
        <app-select formControlName="averageAmountPerInvoice" [options]="averageAmountPerInvoiceOptions" valueField="value" textField="text"
          label="Monto promedio por factura"></app-select>
      </div>
      <app-select
        formControlName="declaredAssets"
        [options]="declaredAssetsOptions"
        valueField="value"
        textField="text"
        [multiple]="true"
        label="Selecciona si la empresa cuenta con bienes inscritos en registros públicos"
      ></app-select>
    </div>
    <p class="laft-form--text-indicator laft-form--text-indicator-bold u-mb-4">Dirección fiscal</p>
    <div class="form-group-3">
      <app-select formControlName="department" [options]="departmentOptions" valueField="value" textField="text"
        label="Departamento" [isDisabled]="isDepartmentDisabled"></app-select>
      <app-select formControlName="province" [options]="provinceOptions" valueField="value" textField="text"
        label="Provincia" [isDisabled]="isProvinceDisabled"></app-select>
      <app-select formControlName="district" [options]="districtOptions" valueField="value" textField="text"
        label="Distrito" [isDisabled]="isDistrictDisabled"></app-select>
    </div>
    <app-input formControlName="address" label="Dirección"></app-input>
    <div class="laft-form--input-phone">
      <span class="laft-form--input-phone-label"
        [ngClass]="officePhoneError ? 'laft-form--input-phone-label-error' : ''">
        Número de la oficina <span *ngIf="officePhoneError"> ({{ officePhoneError }})</span>
      </span>
      <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
        [enablePlaceholder]="true" customPlaceholder="Ingresa tu número" [searchCountryFlag]="true"
        [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
        [selectedCountryISO]="countryISO.Peru" [maxLength]="officePhoneMaxDigit" [phoneValidation]="true"
        [separateDialCode]="true" [numberFormat]="phoneNumberFormat.International"
        searchCountryPlaceholder="Elegir país" formControlName="officePhone" (focusout)="focusOutOfficePhone()"
        (countryChange)="officePhoneCountryChange($event)">
      </ngx-intl-tel-input>
    </div>
    <div class="u-mt-3">
      <p class="laft-form--text-indicator laft-form--text-indicator-bold u-mb-6">Copia literal</p>
      <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s" formats="image+pdf"
        [getFileName]="true" [initialLabel]="'Subir copia literal'" formControlName="copiaLiteral"
        (onFileLoaded)="onCopiaLiteralFileLoaded($event)">
      </lib-file-upload>
      <app-section-message
        *ngIf="isCopiaLiteralTooLarge"
        [text]="'El archivo supera el límite de ' + maxUploadFileSizeMb + ' MB.'"
        type="warning"
      ></app-section-message>
    </div>
    <div class="form-group-2" *ngIf="role === Roles.CLIENT">
      <app-input formControlName="recordNumber" label="Partida Electrónica" maxlength="100"></app-input>
      <app-input formControlName="registryZoneNumber" label="Zona registral" maxlength="100"></app-input>
    </div>
  </section>
  <section class="laft-form--group">
    <p class="laft-form--group-title">Representante legal</p>
    <div class="form-group-2">
      <app-input formControlName="representativeNames" label="Nombres" maxlength="100"></app-input>
      <app-input formControlName="representativeLastNames" label="Apellidos" maxlength="100"></app-input>
    </div>
    <div class="form-group-2">
      <app-input formControlName="representativeEmail" label="Email" type="email"></app-input>
      <div class="laft-form--input-phone">
        <span class="laft-form--input-phone-label"
          [ngClass]="representativePhoneError ? 'laft-form--input-phone-label-error' : ''">
          Teléfono del representante legal <span *ngIf="representativePhoneError"> ({{ representativePhoneError }})</span>
        </span>
        <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
          [enablePlaceholder]="true" customPlaceholder="Ingresa el número" [searchCountryFlag]="true"
          [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
          [selectedCountryISO]="countryISO.Peru" [maxLength]="representativePhoneMaxDigit"
          [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="phoneNumberFormat.International"
          searchCountryPlaceholder="Elegir país" formControlName="representativePhone"
          (focusout)="focusOutRepresentativePhone()" (countryChange)="representativePhoneCountryChange($event)">
        </ngx-intl-tel-input>
      </div>
    </div>
    <div class="form-group-2 u-mt-2">
      <app-select formControlName="representativeIdType" label="Tipo de documento"
        [options]="idTypeOptions"></app-select>
      <app-input formControlName="representativeIdNumber" label="Número de documento" maxlength="100"></app-input>
    </div>
    <div class="form-group-2">
      <div>
        <p class="laft-form--text-indicator u-mb-3">Parte frontal del documento de identidad</p>
        <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s"
          *ngIf="selectedRepresentativeIdType === 'passport'" formats="image+pdf" [getFileName]="true"
          [initialLabel]="'Foto del pasaporte'" formControlName="representativeIdFrontPicture">
        </lib-file-upload>
        <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s"
          *ngIf="selectedRepresentativeIdType !== 'passport'" formats="image+pdf" [getFileName]="true"
          [initialLabel]="'Parte frontal'" formControlName="representativeIdFrontPicture">
        </lib-file-upload>
      </div>
      <div *ngIf="selectedRepresentativeIdType !== 'passport'">
        <p class="laft-form--text-indicator u-mb-3">Parte posterior del documento de identidad</p>
        <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s" formats="image+pdf"
          [getFileName]="true" [initialLabel]="'Parte posterior'" formControlName="representativeIdBackPicture">
        </lib-file-upload>
      </div>
    </div>

      <!-- <div class="form-group-5">
        <div>
          <p class="laft-form--title u-mb-4">Representación por:</p>
          <mat-radio-group formControlName="legalPowerType">
            <mat-radio-button value="power">Poder</mat-radio-button>
            <mat-radio-button value="mandato">Mandato</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <p class="laft-form--title u-mb-4">Datos del instrumento público notarial</p>
          <mat-radio-group formControlName="legalPublicInstrument">
            <mat-radio-button value="escritura_publica">Escritura pública</mat-radio-button>
            <mat-radio-button value="copia_acta">Copia certificada del acta</mat-radio-button>
            <mat-radio-button value="otro">Otro</mat-radio-button>
          </mat-radio-group>
          <div class="u-mt-4">
            <div class="form-group-2" *ngIf="companyDataForm?.get('legalPublicInstrument')?.value==='escritura_publica'">
              <app-input formControlName="notarioNames" label="Nombres y apellidos del notario"
                maxlength="100"></app-input>
              <app-date-picker formControlName="escrituraPublicaDate"
                label="Fecha de escritura pública"></app-date-picker>
            </div>
            <div class="form-group-2" *ngIf="companyDataForm?.get('legalPublicInstrument')?.value==='copia_acta'">
              <app-date-picker formControlName="certificateCopyDate" label="Fecha de copia certificada"></app-date-picker>
              <app-date-picker formControlName="actaDate" label="Fecha del acta"></app-date-picker>
            </div>
            <div class="form-group-2" *ngIf="companyDataForm?.get('legalPublicInstrument')?.value==='otro'">
              <app-input formControlName="otherInstrument" label="Especifique" maxlength="100"></app-input>
            </div>
          </div>
        </div>
      </div> -->
    <!-- <div class="laft-form--registration-record">
      <p class="laft-form--registration-record-title">Datos de inscripción registral</p>
      <div *ngIf="role !== Roles.CLIENT">
        <div class="form-group-2">
          <app-input formControlName="recordNumber" label="Partida N°" maxlength="100"></app-input>
          <app-input formControlName="entryNumber" label="Asiento N°" maxlength="100"></app-input>
        </div>
        <div class="form-group-2">
          <app-input formControlName="businessSector" label="Rubro" maxlength="100"></app-input>
          <app-input formControlName="registryZoneNumber" label="Zona registral N°" maxlength="100"></app-input>
        </div>
      </div>
      <div class="form-group-2" *ngIf="role === Roles.CLIENT">
        <app-input formControlName="entryNumber" label="Asiento N°" maxlength="100"></app-input>
        <app-input formControlName="businessSector" label="Rubro" maxlength="100"></app-input>
      </div>
    </div> -->

    <div class="laft-form--checkbox">
      <app-checkbox formControlName="requiresJointSignature"></app-checkbox>
      <p class="u-mt-1 laft-form--text-indicator" *ngIf="role === Roles.CLIENT">
        El representante legal necesita firma conjunta
      </p>
      <p class="u-mt-1 laft-form--text-indicator" *ngIf="role !== Roles.CLIENT">
        Necesita firma conjunta para el
        <span class="bold-600 blue"><a class="bold-600 blue"
            href="https://storage.googleapis.com/finsmart-websitefiles/legal/Contrato%20del%20inversionista%20v3.2.docx.pdf"
            target="_blank">Contrato de Inversionista</a></span>
      </p>
    </div>
    <div class="laft-form--actions" *ngIf="companyDataForm?.get('requiresJointSignature')?.value">
      <p class="laft-form--group-title">Segundo Representante legal</p>
      <div class="form-group-2">
        <app-input formControlName="secondRepresentativeNames" label="Nombres" maxlength="100"></app-input>
        <app-input formControlName="secondRepresentativeLastNames" label="Apellidos" maxlength="100"></app-input>
      </div>
      <div class="form-group-2">
        <app-input formControlName="secondRepresentativeEmail" label="Email" type="email"></app-input>
        <div class="laft-form--input-phone">
          <span class="laft-form--input-phone-label"
            [ngClass]="secondRepresentativePhoneError ? 'laft-form--input-phone-label-error' : ''">
            Teléfono del representante legal <span *ngIf="secondRepresentativePhoneError"> ({{ secondRepresentativePhoneError }})</span>
          </span>
          <ngx-intl-tel-input [preferredCountries]="preferredCountries" [enableAutoCountrySelect]="true"
            [enablePlaceholder]="true" customPlaceholder="Ingresa el número" [searchCountryFlag]="true"
            [searchCountryField]="[searchCountryField.Iso2, searchCountryField.Name]" [selectFirstCountry]="false"
            [selectedCountryISO]="countryISO.Peru" [maxLength]="secondRepresentativePhoneMaxDigit"
            [phoneValidation]="true" [separateDialCode]="true" [numberFormat]="phoneNumberFormat.International"
            searchCountryPlaceholder="Elegir país" formControlName="secondRepresentativePhone"
            (focusout)="focusOutSecondRepresentativePhone()" (countryChange)="secondRepresentativePhoneCountryChange($event)">
          </ngx-intl-tel-input>
        </div>
      </div>
      <div class="form-group-2 u-mt-2">
        <app-select formControlName="secondRepresentativeIdType" label="Tipo de documento"
          [options]="idTypeOptions"></app-select>
        <app-input formControlName="secondRepresentativeNumber" label="Número de documento" maxlength="100"></app-input>
      </div>
      <div class="form-group-2">
        <div>
          <p class="laft-form--text-indicator u-mb-3">Parte frontal del documento de identidad</p>
          <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s"
            *ngIf="this.companyDataForm?.get('secondRepresentativeIdType')?.value === 'passport'" formats="image+pdf" [getFileName]="true"
            [initialLabel]="'Foto del pasaporte'" formControlName="secondRepresentativeIdFrontPicture">
          </lib-file-upload>
          <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s"
            *ngIf="this.companyDataForm?.get('secondRepresentativeIdType')?.value !== 'passport'" formats="image+pdf" [getFileName]="true"
            [initialLabel]="'Parte frontal'" formControlName="secondRepresentativeIdFrontPicture">
          </lib-file-upload>
        </div>
        <div *ngIf="this.companyDataForm?.get('secondRepresentativeIdType')?.value !== 'passport'">
          <p class="laft-form--text-indicator u-mb-3">Parte posterior del documento de identidad</p>
          <lib-file-upload label="Documento" [iconUpload]="true" internalSpacing="s" formats="image+pdf"
            [getFileName]="true" [initialLabel]="'Parte posterior'" formControlName="secondRepresentativeIdBackPicture">
          </lib-file-upload>
        </div>
      </div>

      <!-- <div class="form-group-5">
        <div>
          <p class="laft-form--title u-mb-4">Representación por:</p>
          <mat-radio-group formControlName="secondRepresentativeLegalPowerType">
            <mat-radio-button value="power">Poder</mat-radio-button>
            <mat-radio-button value="mandato">Mandato</mat-radio-button>
          </mat-radio-group>
        </div>
        <div>
          <p class="laft-form--title u-mb-4">Datos del instrumento público notarial</p>
          <mat-radio-group formControlName="secondRepresentativeLegalPublicInstrument">
            <mat-radio-button value="escritura_publica">Escritura pública</mat-radio-button>
            <mat-radio-button value="copia_acta">Copia certificada del acta</mat-radio-button>
            <mat-radio-button value="otro">Otro</mat-radio-button>
          </mat-radio-group>
          <div class="u-mt-4">
            <div class="form-group-2"
              *ngIf="companyDataForm?.get('secondRepresentativeLegalPublicInstrument')?.value==='escritura_publica'">
              <app-input formControlName="secondRepresentativeNotarioNames" label="Nombres y apellidos del notario"
                maxlength="100"></app-input>
              <app-date-picker formControlName="secondRepresentativeEscrituraPublicaDate"
                label="Fecha de escritura pública"></app-date-picker>
            </div>
            <div class="form-group-2" *ngIf="companyDataForm?.get('secondRepresentativeLegalPublicInstrument')?.value==='copia_acta'">
              <app-date-picker formControlName="secondRepresentativeCertificateCopyDate"
                label="Fecha de copia certificada"></app-date-picker>
              <app-date-picker formControlName="secondRepresentativeActaDate" label="Fecha del acta"></app-date-picker>
            </div>
            <div class="form-group-2" *ngIf="companyDataForm?.get('secondRepresentativeLegalPublicInstrument')?.value==='otro'">
              <app-input formControlName="secondRepresentativeOtherInstrument" label="Especifique" maxlength="100"></app-input>
            </div>
          </div>
        </div>
      </div> -->
      <!-- <div class="laft-form--registration-record">
        <p class="laft-form--registration-record-title">Datos de inscripción registral</p>
        <div *ngIf="role !== Roles.CLIENT">
          <div class="form-group-2">
            <app-input formControlName="secondRepresentativeRecordNumber" label="Partida N°" maxlength="100"></app-input>
            <app-input formControlName="secondRepresentativeEntryNumber" label="Asiento N°" maxlength="100"></app-input>
          </div>
          <div class="form-group-2">
            <app-input formControlName="secondRepresentativeBusinessSector" label="Rubro" maxlength="100"></app-input>
            <app-input formControlName="secondRepresentativeRegistryZoneNumber" label="Zona registral N°" maxlength="100"></app-input>
          </div>
        </div>
        <div class="form-group-2" *ngIf="role === Roles.CLIENT">
          <app-input formControlName="secondRepresentativeEntryNumber" label="Asiento N°" maxlength="100"></app-input>
          <app-input formControlName="secondRepresentativeBusinessSector" label="Rubro" maxlength="100"></app-input>
        </div>
      </div> -->
    </div>
  </section>
  <div class="laft-form--actions">
    <button type="button" class="laft-form--btn-submit" (click)="onContinue()">Continuar</button>
  </div>
</form>